const accessibility = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const menuLinks = document.querySelectorAll(".menu-link");
    const dropdownLinks = document.querySelectorAll(".menu-link_dropdown");

    menuLinks.forEach(mLink => {
      mLink.addEventListener("focus", () => {

      })
    });

    document.querySelectorAll('.site-menu.js-site-menu').forEach(item => {
      item.setAttribute('inert', '');
      item.querySelectorAll('a').forEach(link => {
        link.setAttribute('tabindex', '-1');
      });
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === "class") {
            if (item.classList.contains('is-open')) {
              item.removeAttribute('inert');
              item.querySelectorAll('a').forEach(link => {
                link.removeAttribute('tabindex');
              });
            } else {
              item.setAttribute('inert', '');
              item.querySelectorAll('a').forEach(link => {
                link.setAttribute('tabindex', '-1');
              });
            }
          }
        });
      });
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    dropdownLinks.forEach(dLink => {
      dLink.addEventListener("focusin", () => {
        dLink.closest('header').classList.add('mega-menu-open');
      });

      dLink.addEventListener("focusout", () => {
        dLink.closest('header').classList.remove('mega-menu-open');
      });
    });

    document.querySelectorAll('a, section').forEach((link) => {
      link.addEventListener('focus', () => {
        link.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    document.querySelectorAll('.filter-accordion__item').forEach(item => {
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          const checkbox = item.querySelector('input[type="checkbox"]');
          if (checkbox) {
            checkbox.click();
            checkbox.focus();
          }
        }
      });
    });

    document.querySelectorAll('.jobs-search.js-jobs-search').forEach(item => {
      item.setAttribute('inert', '');
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === "class") {
            if (item.classList.contains('is-active')) {
              item.removeAttribute('inert');
              item.focus();
            } else {
              item.blur();
              item.setAttribute('inert', '');
              const jobLink = document.querySelector('.header__nav .js-jobs-link');
              const mainContent = jobLink.closest('section');
              if (mainContent) {
                mainContent.setAttribute('tabindex', '-1');
                mainContent.focus();
              }
            }
          }
        });
      });

      observer.observe(item, { attributes: true, attributeFilter: ['class'] });

      if (!item.hasAttribute('tabindex')) {
        item.setAttribute('tabindex', '-1');
      }
    });

    document.querySelectorAll('.share-icon').forEach(item => {
      item.addEventListener('focus', () => {
        const parent = item.closest('.share-block');
        if (parent) {
          parent.classList.add('is-active');
        }
      });

      item.addEventListener('blur', () => {
        const parent = item.closest('.share-block');
        if (parent) {
          parent.classList.remove('is-active');
        }
      });
    });

  })
};

export default accessibility;